/**
 * Content hashing for sync manifests.
 *
 * Mirrors `SyncContentHash.sha256Hex`: the hex SHA-256 of the exact bytes
 * stored in the object. Both ends must hash identical bytes, which is why
 * every manifest-writing path goes through `encodeSyncJSON`.
 */
export async function sha256Hex(data: Uint8Array): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', data as BufferSource);
  return [...new Uint8Array(digest)]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function textSha256Hex(text: string): Promise<string> {
  return sha256Hex(new TextEncoder().encode(text));
}
